/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not load the ledger." |
*
* @param {Promo_Ledger_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_error = /** @type {((inputs?: Promo_Ledger_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de charger le registre.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo cargar el registro.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível carregar o registro.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile caricare il registro.")
	return /** @type {LocalizedString} */ ("Could not load the ledger.")
});